import { Injectable } from '@angular/core';
import { Preferences } from '@capacitor/preferences';
import { BehaviorSubject, interval, Subscription } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LikesService {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  private userDataSubject = new BehaviorSubject<any>(null);
  public userData$ = this.userDataSubject.asObservable();
  private pollSubscription: Subscription;

  constructor(){
    this.loadInitialUserData();
    this.pollSubscription = interval(3000).subscribe(() => {
      this.refreshUserData();
    });
  }

  async loadInitialUserData() {
    const result = await Preferences.get({ key: 'USER_DATA' });
    const userData = result.value ? JSON.parse(result.value) : null;
    this.userDataSubject.next(userData);
  }

  async refreshUserData() {
    const result = await Preferences.get({ key: 'USER_DATA' });
    const userData = result.value ? JSON.parse(result.value) : null;
    // Only emit if data has actually changed to prevent unnecessary refreshes
    if (JSON.stringify(userData) !== JSON.stringify(this.userDataSubject.value)) {
      this.userDataSubject.next(userData);
    }
  }
}
